import { cn } from '@antimatterhq/ui/lib/utils';
import { FormCodeEditorProps } from '../../code/FormCodeEditor';
import {
  FormCodeEditor,
  FormSqlExpressionInputProps,
} from '@/components/form/form';

export type FormSqlJoinInputProps = FormCodeEditorProps;

export const FormSqlJoinInput = ({
  name,
  className,
  placeholder = 'E.g. lhs_column = rhs_column',
  ...props
}: FormSqlExpressionInputProps) => {
  return (
    <FormCodeEditor
      name={name}
      placeholder={placeholder}
      className={cn('min-h-[40px] max-w-form', className)}
      hideControls
      {...props}
    />
  );
};
